// Crown Vic racing image pool - authentic photos from the community
export const CROWN_VIC_IMAGES = [
  "https://customer-assets.emergentagent.com/job_crown-vic-central/artifacts/fml311ba_341040780_3390030624586050_8184513587913407132_n.jpg",
  "https://customer-assets.emergentagent.com/job_crown-vic-central/artifacts/qd2jg0h3_133627356_web1_08242024st-essex-motorsports-pic.jpg",
  "https://customer-assets.emergentagent.com/job_crown-vic-central/artifacts/jx3zo1pu_486015680_1107461591409387_507467326338540483_n.jpg",
  "https://customer-assets.emergentagent.com/job_crown-vic-central/artifacts/rlane5tc_crown-vic-15.jpg",
  "https://customer-assets.emergentagent.com/job_crown-vic-central/artifacts/1z6jxwpc_Crown-Vic-Promo-Photo-Dan-Vining-Photo.jpg",
  "https://customer-assets.emergentagent.com/job_crown-vic-central/artifacts/vekwu4m2_Devils%20Bowl%20Speedway.jpg",
];

// Hero image - pack of Crown Vics racing at night
export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_crown-vic-central/artifacts/9hqm035z_crownvic%20nation%20fb%20pic.png";

// Get a deterministic image based on an id/index (so same article always gets same image)
export function getCrownVicImage(seed) {
  if (!seed) return CROWN_VIC_IMAGES[0];
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = ((hash << 5) - hash) + seed.charCodeAt(i);
    hash |= 0;
  }
  return CROWN_VIC_IMAGES[Math.abs(hash) % CROWN_VIC_IMAGES.length];
}

// Fallback handler for broken images
export function handleImageError(e, seed) {
  e.target.src = getCrownVicImage(seed || 'fallback');
}
